var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass:
        "absolute right-9 top-52 -mt-3 z-10 mb-5 pb-6 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none",
      attrs: {
        role: "menu",
        "aria-orientation": "vertical",
        "aria-labelledby": "menu-button",
        tabindex: "-1",
      },
    },
    [
      _c("div", [
        _c("div", [
          _c("a", { staticClass: "flex", attrs: { href: "#" } }, [
            _c("img", {
              staticClass: "mx-auto h-6 w-auto mr-3 mt-5",
              attrs: {
                src: require("@/assets/Close.svg"),
                alt: "close filtere",
              },
              on: { click: _vm.closeModal },
            }),
          ]),
        ]),
        _c(
          "div",
          { staticClass: "mr-96 p-6" },
          [
            _c("UiButton", {
              staticClass: "mt-1 flex-shrink-0",
              attrs: { variant: "filter", buttonText: "Clear All" },
              on: { click: _vm.clearFilters },
            }),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "grid grid-cols-2" },
          [
            _c(
              "FormGroup",
              { staticClass: "px-6", attrs: { title: "Country" } },
              [
                _c("ProfileCountrySelect", {
                  attrs: { multiple: "" },
                  model: {
                    value: _vm.filterFields.countries,
                    callback: function ($$v) {
                      _vm.$set(_vm.filterFields, "countries", $$v)
                    },
                    expression: "filterFields.countries",
                  },
                }),
              ],
              1
            ),
            _c(
              "FormGroup",
              { staticClass: "px-6 -ml-6" },
              [
                _c("RegionInput", {
                  attrs: {
                    countries: _vm.filterFields.countries,
                    multiple: "",
                  },
                  model: {
                    value: _vm.filterFields.states,
                    callback: function ($$v) {
                      _vm.$set(_vm.filterFields, "states", $$v)
                    },
                    expression: "filterFields.states",
                  },
                }),
              ],
              1
            ),
            _c(
              "FormGroup",
              { staticClass: "px-6", attrs: { title: "City" } },
              [
                _c("ProjectCityMultiselect", {
                  attrs: {
                    country: _vm.countriesNames,
                    state: _vm.statesNames,
                  },
                  model: {
                    value: _vm.filterFields.cities,
                    callback: function ($$v) {
                      _vm.$set(_vm.filterFields, "cities", $$v)
                    },
                    expression: "filterFields.cities",
                  },
                }),
              ],
              1
            ),
            _c(
              "FormGroup",
              { staticClass: "px-6 -ml-6", attrs: { title: "Time Range" } },
              [
                _c("FormDateRangePicker", {
                  attrs: { value: _vm.dateRange },
                  on: { input: _vm.handleDateRangeChange },
                }),
              ],
              1
            ),
            _c(
              "FormGroup",
              { staticClass: "px-6", attrs: { title: "Project Criteria" } },
              [
                _c("ProjectCriteriaMultiselect", {
                  attrs: { isManager: _vm.isManager },
                  model: {
                    value: _vm.filterFields.criteria,
                    callback: function ($$v) {
                      _vm.$set(_vm.filterFields, "criteria", $$v)
                    },
                    expression: "filterFields.criteria",
                  },
                }),
              ],
              1
            ),
            _c(
              "FormGroup",
              {
                staticClass: "px-6 -ml-6 dropdownMaxWidth",
                attrs: { title: "Project Name" },
                model: {
                  value: _vm.showProjects,
                  callback: function ($$v) {
                    _vm.showProjects = $$v
                  },
                  expression: "showProjects",
                },
              },
              [
                _c("ProjectsMultiselect", {
                  attrs: { max: 5, selectedInline: "", withoutLoading: "" },
                  model: {
                    value: _vm.selectedProjectsIds,
                    callback: function ($$v) {
                      _vm.selectedProjectsIds = $$v
                    },
                    expression: "selectedProjectsIds",
                  },
                }),
              ],
              1
            ),
            _c(
              "FormGroup",
              { staticClass: "px-6", attrs: { title: "Project Status" } },
              [
                _c("ProjectStatusSelect", {
                  model: {
                    value: _vm.filterFields.status,
                    callback: function ($$v) {
                      _vm.$set(_vm.filterFields, "status", $$v)
                    },
                    expression: "filterFields.status",
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }